export const SUPPORTED_LANGUAGES = [
  {
    identifier: "en",
    name: "English",
  },
  {
    identifier: "hi",
    name: "हिंदी",
  },
  {
    identifier: "zh",
    name: "中国人",
  },
  {
    identifier: "es",
    name: "española",
  },
];
